import React from "react";
import classnames from "classnames";

const IconCreator = props => {
    let { icon } = props;
    let country, creator;

    if (icon && icon.uploader) {
        if (icon.uploader.location) {
            country = icon.uploader.location.split(", ");
            country = country[country.length - 1];
            country = <span className="uploader-location">, {country}</span>;
        }
        if (icon.uploader.name) {
            creator = (
                <span>
                    By{" "}
                    <a href={icon.uploader.permalink}>{icon.uploader.name}</a>
                    {country}
                </span>
            );
        }
    }

    return <div className="designer">{creator}&nbsp;</div>;
};

export default IconCreator;
